var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('contribute-form-panel');
import { breakpoints, theme } from '@shapeable/theme';
import { HidePanelButton } from './hide-panel-button';
import { Icons } from '../icons';
import { useContributeForm } from '../../hooks/use-contribute-form';
import { ContributeForm } from './contribute-form';
export var ContributeFormPanelDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #000;\n    box-sizing: border-box;\n    position: relative;\n    height: 100vh;\n    max-height: 1040px;\n  "], ["\n    background: #000;\n    box-sizing: border-box;\n    position: relative;\n    height: 100vh;\n    max-height: 1040px;\n  "])))
});
var HideButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    display: none;\n\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    display: none;\n\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var HideButtonHorizontalStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 100%;\n  "], ["\n    flex-shrink: 0;\n    flex-grow: 1;\n    width: 100%;\n  "]))),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var FormStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    position: absolute;\n    top: 42px;\n    // height: calc(100% - 42px);\n    height: 100vh;\n    overflow-y: auto;\n  "], ["\n    padding: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    position: absolute;\n    top: 42px;\n    // height: calc(100% - 42px);\n    height: 100vh;\n    overflow-y: auto;\n  "])), theme.UNIT(4)),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    top: 0px;\n    left: 54px;\n    height: 100%;\n    width: calc(100% - 54px);\n  "], ["\n    top: 0px;\n    left: 54px;\n    height: 100%;\n    width: calc(100% - 54px);\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  HideButton: styled(HidePanelButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), HideButtonStyles),
  Form: styled(ContributeForm)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  HideButtonHorizontal: styled(HidePanelButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HideButtonHorizontalStyles)
};
export var ContributeFormPanel = function ContributeFormPanel(props) {
  var className = props.className;
  var contributeForm = useContributeForm();

  var onContainerClick = function onContainerClick(event) {
    event.stopPropagation();
  };

  return React.createElement(My.Container, {
    onClick: onContainerClick,
    className: cls.name(className)
  }, React.createElement(My.HideButtonHorizontal, {
    icon: React.createElement(Icons.ChatBubble, null),
    label: "HIDE",
    onClick: contributeForm.hideOnClick
  }), React.createElement(My.HideButton, {
    icon: React.createElement(Icons.ChatBubble, null),
    label: "HIDE",
    isVertical: true,
    onClick: contributeForm.hideOnClick
  }), React.createElement(My.Form, null));
};
ContributeFormPanel.defaultProps = ContributeFormPanelDefaultProps;
ContributeFormPanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;